var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vyopta-single-filter",
      class: { "quick-pick": _vm.isQuickPick },
    },
    [
      _vm.legacyMode ? _c("div", { staticClass: "header" }) : _vm._e(),
      _vm._v(" "),
      _vm.legacyMode
        ? _c("div", { staticClass: "pillOnly" }, [
            _c("span", { staticClass: "pillText" }, [
              _vm._v(_vm._s(_vm.filter.text)),
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "remove-filter fa fa-times",
              on: { click: _vm.removeFilter },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.legacyMode
        ? _c("div", { staticClass: "newFilter" }, [
            _c("div", { staticClass: "header" }, [
              _c(
                "div",
                { staticClass: "leftHeader", class: { static: _vm.isStatic } },
                [
                  _vm.currentFilter.field
                    ? _c(
                        "span",
                        {
                          staticClass: "fieldName",
                          class: {
                            qualityFilterHeader: _vm.qualitySpecialCase,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.currentFilter.fieldText) +
                              "\n          "
                          ),
                          _vm.showGenericTooltip && !_vm.showQualityTooltip
                            ? _c(
                                "i-v-tooltip",
                                {
                                  attrs: {
                                    color: "var(--tooltip-background)",
                                    top: "",
                                    "z-index": "10000",
                                    "content-class":
                                      "above single-filter-quick-pick-tt",
                                    interactive: "",
                                    opacity: 1,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "info-btn" },
                                              [
                                                _c(
                                                  "i",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "far fa-info-circle",
                                                    },
                                                    on
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1418001681
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "quick-pick-tt quick-pick-tt-legend",
                                    },
                                    _vm._l(
                                      _vm.quickPickFilterConfig,
                                      function (config, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "quick-pick-tt-legend-item",
                                          },
                                          [
                                            config.icon
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "quick-pick-tt-legend-icon",
                                                    class: config.colorClass,
                                                  },
                                                  [
                                                    _c("i", {
                                                      class: config.icon,
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            config.svgSrc
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "quick-pick-tt-legend-svg",
                                                    class: config.colorClass,
                                                  },
                                                  [
                                                    _c("img", {
                                                      class: config.svgClass,
                                                      attrs: {
                                                        src: config.svgSrc,
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "quick-pick-tt-legend-label",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(config.legendTitle)
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showQualityTooltip
                            ? _c(
                                "i-v-tooltip",
                                {
                                  attrs: {
                                    color: "var(--tooltip-background)",
                                    top: "",
                                    "z-index": "10000",
                                    "content-class":
                                      "above single-filter-quick-pick-tt",
                                    interactive: "",
                                    opacity: 1,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "span",
                                              { staticClass: "info-btn" },
                                              [
                                                _c(
                                                  "i",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "far fa-info-circle",
                                                    },
                                                    on
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1418001681
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("div", { staticClass: "quick-pick-tt" }, [
                                    _c(
                                      "div",
                                      { staticClass: "quick-pick-tt-header" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-check-circle semantic-good",
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "quick-pick-tt-header-text",
                                          },
                                          [_vm._v("Good")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "quick-pick-tt-header-middle-text",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fas fa-minus-circle semantic-fair",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "quick-pick-tt-header-text",
                                              },
                                              [_vm._v("Fair")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-circle semantic-bad",
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "quick-pick-tt-header-text",
                                          },
                                          [_vm._v("Bad")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "quick-pick-tt-body" },
                                      [
                                        _vm._v(
                                          "WXP Collaboration quality algorithm"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "quick-pick-tt-header" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-question-circle semantic-neutral",
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "quick-pick-tt-header-text",
                                          },
                                          [_vm._v("Unknown")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "quick-pick-tt-body" },
                                      [_vm._v("Quality data unavailable")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "quick-pick-tt-link" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.brandingService.getSupportUrl(
                                                "qualityImprovements"
                                              ),
                                              target: "_blank",
                                              title: "Learn More",
                                            },
                                          },
                                          [_vm._v("Learn More")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentFilter.operatorText
                    ? _c(
                        "span",
                        {
                          staticClass: "operatorName",
                          class: {
                            qualityFilterHeader: _vm.qualitySpecialCase,
                            truncateOperator: _vm.isTruncatedOperator,
                          },
                          on: { click: _vm.operatorHeaderClicked },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.currentFilter.operatorText) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "rightHeader" }, [
                _c("i", {
                  staticClass: "delete fas fa-times-circle",
                  attrs: { title: "Delete" },
                  on: { click: _vm.removeFilter },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: { field: true, shown: !_vm.fieldComplete } },
              [
                _c("v-autocomplete", {
                  ref: "fieldInput",
                  staticClass: "autocomplete",
                  attrs: {
                    placeholder: "Search Attributes",
                    items: _vm.fieldOptions,
                    solo: "",
                    "menu-props": { contentClass: "field-input-menu" },
                  },
                  on: {
                    "hook:mounted": _vm.fieldInputMounted,
                    input: _vm.handleFieldSubmit,
                  },
                  model: {
                    value: _vm.currentFilter.field,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentFilter, "field", $$v)
                    },
                    expression: "currentFilter.field",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  operator: true,
                  shown: _vm.fieldComplete && !_vm.operatorComplete,
                },
              },
              [
                _c("v-select", {
                  ref: "selectInput",
                  attrs: {
                    items: _vm.getOperators(),
                    solo: "",
                    placeholder: "Select Operator",
                    "menu-props": {
                      contentClass: "optionsMenu",
                      closeOnContentClick: true,
                      maxHeight: "75%",
                    },
                  },
                  on: { input: _vm.onOperatorChange },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "no-data",
                        fn: function () {
                          return [
                            _c("div", {
                              staticStyle: { height: "0", width: "0" },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "prepend-item",
                        fn: function () {
                          return [
                            _vm.quickPickImage
                              ? _c(
                                  "v-list-item",
                                  {
                                    on: { click: _vm.handleQuickPickSelected },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "quick-pick-text" },
                                      [_vm._v("is")]
                                    ),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "quick-pick-image",
                                      attrs: { src: _vm.quickPickImage },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.quickPickImage ? _c("v-divider") : _vm._e(),
                            _vm._v(" "),
                            _vm.hasKnownValuesAndNotAList
                              ? _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: () =>
                                        _vm.onOperatorChange({
                                          text: "in",
                                          value: "=in=(|)",
                                          useId: true,
                                        }),
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "option-text" }, [
                                      _vm._v("in"),
                                    ]),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "option-image",
                                      attrs: { src: "dist/images/in-icon.png" },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasKnownValuesAndNotAList
                              ? _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: () =>
                                        _vm.onOperatorChange({
                                          text: "not in",
                                          value: "=out=(|)",
                                          useId: true,
                                        }),
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "option-text" }, [
                                      _vm._v("not in"),
                                    ]),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticClass: "option-image",
                                      attrs: {
                                        src: "dist/images/not-in-icon.png",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasKnownValuesAndNotAList
                              ? _c("v-divider")
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1415548950
                  ),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: {
                  value: true,
                  shown: _vm.fieldComplete && _vm.operatorComplete,
                },
              },
              [
                _c("v-text-field", {
                  ref: "textInput",
                  class: {
                    textValue: true,
                    shown: _vm.valueType === "text" && !_vm.isQuickPick,
                    complete: _vm.filterComplete,
                  },
                  attrs: { solo: "", placeholder: "Enter value" },
                  on: {
                    keydown: _vm.onChange,
                    blur: _vm.onValueSubmit,
                    click: _vm.onValueClick,
                  },
                  model: {
                    value: _vm.currentFilter.queryVar,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentFilter, "queryVar", $$v)
                    },
                    expression: "currentFilter.queryVar",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  class: {
                    textValue: true,
                    shown: _vm.valueType === "noValue",
                    complete: true,
                  },
                  attrs: {
                    solo: "",
                    disabled: "",
                    placeholder:
                      _vm.currentFilter.operatorText === "is empty"
                        ? "no value"
                        : "any value",
                  },
                  on: { click: _vm.onValueClick },
                  model: {
                    value: _vm.currentFilter.shortText,
                    callback: function ($$v) {
                      _vm.$set(_vm.currentFilter, "shortText", $$v)
                    },
                    expression: "currentFilter.shortText",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "select",
                    class: {
                      filterValueSelect: true,
                      shown: _vm.valueType === "list",
                    },
                    style: _vm.filterWidth
                      ? "min-width:" + _vm.filterWidth + ";"
                      : "",
                  },
                  [
                    !_vm.showList
                      ? _c("div", {
                          directives: [
                            {
                              name: "dompurify-html",
                              rawName: "v-dompurify-html",
                              value:
                                _vm.currentFilter.shortText ||
                                _vm.currentFilter.text ||
                                "All",
                              expression:
                                "currentFilter.shortText || currentFilter.text || 'All'",
                            },
                          ],
                          class: {
                            listValueDisplay: true,
                            filterLookalike: true,
                            complete: _vm.filterComplete,
                          },
                          on: { click: _vm.onListValueClick },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: { optionsBox: true, shown: _vm.showList } },
                      [
                        _c("treeselect", {
                          ref: "listSearch",
                          attrs: {
                            options: _vm.newFilterValues,
                            "show-count": true,
                            "show-count-of": "LEAF_DESCENDANTS",
                            "value-consists-of": "LEAF_PRIORITY",
                            "disable-branch-nodes": true,
                            "flatten-search-results": false,
                            "close-on-select": false,
                            "always-open": true,
                            defaultExpandLevel: 0,
                            "search-nested": "",
                            "disable-fuzzy-matching": true,
                            multiple: true,
                            placeholder: "Filter options",
                            normalizer: _vm.normalizer,
                            limit: _vm.selectionLimit,
                            "value-format": "object",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "option-label",
                                fn: function ({
                                  node,
                                  shouldShowCount,
                                  count,
                                  labelClassName,
                                  countClassName,
                                }) {
                                  return _c(
                                    "label",
                                    {
                                      class:
                                        node.isBranch && node.isRootNode
                                          ? "selectOption tree-branch " +
                                            labelClassName
                                          : "selectOption " + labelClassName,
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: node.raw.class
                                            ? node.raw.class + " optionName"
                                            : "optionName",
                                        },
                                        [
                                          node.raw.fa
                                            ? _c("i", { class: node.raw.fa })
                                            : _vm._e(),
                                          _vm._v(
                                            " " +
                                              _vm._s(node.label) +
                                              "\n                "
                                          ),
                                          shouldShowCount
                                            ? _c(
                                                "span",
                                                { class: countClassName },
                                                [
                                                  _vm._v(
                                                    "(" + _vm._s(count) + ")"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      node.raw.beta
                                        ? _c(
                                            "span",
                                            { staticClass: "new-beta badge" },
                                            [_vm._v("beta")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      node.raw.imgUrl
                                        ? _c("img", {
                                            staticClass: "optionImage",
                                            attrs: { src: node.raw.imgUrl },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                },
                              },
                            ],
                            null,
                            false,
                            1141994533
                          ),
                          model: {
                            value: _vm.selectedValuesArray,
                            callback: function ($$v) {
                              _vm.selectedValuesArray = $$v
                            },
                            expression: "selectedValuesArray",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isQuickPick
                  ? _c(
                      "div",
                      { staticClass: "quick-pick" },
                      [
                        _c("QuickPickFilter", {
                          attrs: {
                            widget: _vm.filter.widget,
                            datasetName:
                              _vm.filter.datasetId || _vm.datasetName,
                            fieldName: _vm.quickPickFieldName,
                            initialSelection: _vm.quickPickSelection,
                          },
                          on: {
                            "quick-pick-updated": _vm.handleQuickPickUpdated,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }